import React, { useState } from "react";
import { FileText, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { resolveBackendUrl } from "@/lib/urls";
import { TASK } from "@/constants/testIds";

export default function ReceiptCard({ task, onTaskUpdate }) {
  const [busy, setBusy] = useState(false);
  const existing = task.receipt_path;

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/tasks/${task.task_id}/receipt`);
      onTaskUpdate({
        ...task,
        receipt_path: data.path,
        receipt_size: data.size,
        receipt_num_pages: data.num_pages,
        receipt_test_mode: data.test_mode,
      });
      // Open the PDF in a new tab right away
      window.open(resolveBackendUrl(data.url), "_blank", "noopener");
      toast.success(data.cached ? "Receipt ready" : "Receipt generated");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="eb-card p-6">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--eb-text-dim)]">PDF Receipt</div>
          <h3 className="mt-1 text-xl font-[800]">A keepsake for the family</h3>
          <p className="text-sm text-[var(--eb-text-dim)] mt-1 max-w-md">
            Generate a beautifully-designed PDF with every photo, agent name, timestamps, and your insurance reference — perfect to share with family back home.
            {task.receipt_test_mode === true && (
              <span className="ml-1 italic">(Test PDFs are watermarked.)</span>
            )}
          </p>
        </div>
        <div className="flex items-center gap-2">
          {existing && (
            <a
              href={resolveBackendUrl(`/api/files/${existing}`)}
              target="_blank"
              rel="noopener noreferrer"
              className="eb-btn eb-btn-ghost !py-2 !px-4 !text-sm"
            >
              <Download className="w-4 h-4" /> Download
            </a>
          )}
          <button
            data-testid={TASK.receiptBtn}
            onClick={generate}
            disabled={busy}
            className="eb-btn eb-btn-primary !py-2 !px-4 !text-sm"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
            {busy ? "Generating…" : existing ? "Re-open receipt" : "Generate receipt"}
          </button>
        </div>
      </div>
    </div>
  );
}
